import { createSlice } from '@reduxjs/toolkit';

import {
  loadInvestmentSolutionsItem,
  loadInvestmentSolutionsList,
} from './actions';
import { InvestmentSolutionsState } from './interfaces';

export const investmentSolutions = createSlice({
  name: 'investmentSolutions',
  initialState: {
    list: [],
    item: null,
    limit: 20,
    total: 0,
    offset: 0,
  } as InvestmentSolutionsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadInvestmentSolutionsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(
      loadInvestmentSolutionsItem.fulfilled,
      (state, { payload }) => {
        state.item = payload;
      }
    );
  },
});
